import { render, staticRenderFns } from "./offline.vue?vue&type=template&id=0826b063&scoped=true&"
import script from "./offline.vue?vue&type=script&lang=js&"
export * from "./offline.vue?vue&type=script&lang=js&"
import style0 from "./offline.vue?vue&type=style&index=0&id=0826b063&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0826b063",
  null
  
)

export default component.exports